export enum MediaWarning {
  SlowConnection,
}
